<template>
  <div class="legacy-report-banner">
    <div class="legacy-report-banner__content">
      <gl-icon
        :height="20"
        name="info-icon"
        :width="20"
      />
      Updates for this report are no longer supported. Create a new report to
      access the most recent data under your plan.
    </div>
    <div class="legacy-report-banner__action">
      <GlButton
        title="Generate New Report"
        white
        @click="onReportGenerate"
      />
    </div>
  </div>
</template>

<script>
// components
import GlIcon from '@/components/gl-icon'
import GlButton from '@/components/gl-button'

// vuex
import { mapState } from "vuex";

export default {
  name: 'LegacyReportBanner',
  components: {
    GlIcon,
    GlButton,
  },
  computed: {
    ...mapState('payment', ['currentPlan'])
  },
  methods: {
    onReportGenerate() {
      const query = { ...this.$route.query }

      if (query.isLegacy && this.currentPlan.reportsRemaining === 0) {
        this.$router.push({ name: 'profile' })
        return
      }

      delete query.isLegacy

      this.$router.replace({
        path: this.$route.path,
        query
      }).then(() => {
        window.location.reload()
      })
    }
  },
}
</script>

<style scoped>
.legacy-report-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  gap: 16px;
  padding: 12px 0;
}

.legacy-report-banner__content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--Size-M, 14px);
  font-weight: 600;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
}

@media (max-width: 767px) {
  .legacy-report-banner {
    flex-direction: column;
    align-items: flex-start;
  }
  .legacy-report-banner__action {
    margin-left: 28px;
  }
}
</style>
